<mat-card class="card  width-field-100" >
  <mat-card-content class="card-content t_center">
      <i class="material-icons medium_icon pointer" [routerLink] = "['/']">assignment_late</i>
        <h1> {{ 'generic.generic_error' | translate }} </h1>
        <h3> {{ error_message | translate }}</h3>
  </mat-card-content>
</mat-card>


